import React, { useEffect, useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Form from "react-bootstrap/Form";
import * as Yup from "yup";
import createCustomSchema from "../../fieldValidator/fieldValidator";
import { useNavigate } from "react-router-dom";
import { companyID, getEmployeeLocalDetails } from "../../auth";
import { formatDecimal } from "../../utils/formatDecimal";
import AcknowledgmentPopup from "../../utils/AcknowledgmentPopup";
import Loader from "../Loader";
import api from "../../api/axios";
import {
  checkAllowanceForAbsent,
  getAllowedLeaves,
} from "../../services/leaveService";

const EmployeeLeaveModelPopup = ({
  leave,
  setLeave,
  isModalOpen,
  setIsModalOpen,
  editedID,
  previousLeaveDays,
  setEditedID,
}) => {
  const [selectedDate1, setSelectedDate1] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [appliedLeaveError, setAppliedLeaveError] = useState(null);
  const [leaveTypeData, setLeaveTypeData] = useState([]);

  const fetchLeaveTypeData = async () => {
    const company_id = companyID();
    try {
      const response = await api.get(`leaveType/${company_id}`);
      setLeaveTypeData(response?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };
  const [leaveNotAllow, setLeaveNotAllow] = useState(false);
  const checkCanTakeLeave = async () => {
    try {
      const response = await api.get(`employee_allowance?employee_id=${leave?.employee_id ?? localStorage.getItem("employeeID")}`);
      console.log("response", response)
      if (response?.data?.result[0]?.leave_not_allow == 1) {
        console.log("response?.data?.result[0]?.leave_not_allow", response?.data?.result[0]?.leave_not_allow)
        setLeaveNotAllow(true);
      }
      else {
        setLeaveNotAllow(false);

      }
    }
    catch (error) {
      console.error("Error checking leave permission:", error);
    }
  }

  useEffect(() => {
    checkCanTakeLeave()
    fetchLeaveTypeData();
  }, []);

  useEffect(() => {
    checkCanTakeLeave()
  }, [leave?.employee_id, isModalOpen])

  const [daysError, setDaysError] = useState("");
  const [halfDay, setHalfDay] = useState(false);
  const [showReportees, setShowReportees] = useState(false);
  const [reportingData, setReportingData] = useState([]);
  const [leaveError, setLeaveError] = useState({});
  const [balanceDays, setBalanceDays] = useState(null);
  const [extraLeaveError, setExtraLeaveError] = useState(false);
  const [leaveAppliedInAdvanceError, setLeaveAppliedInAdvanceError] =
    useState("");
  const [unpaidWarning, setUnpaidWarning] = useState(null);
  const [loading, setLoading] = useState({
    show: false,
    message: "",
  });
  const [acknowledgmentPopup, setAcknowledgmentPopup] = useState({
    show: false,
    status: null,
    message: null,
    icon: null,
  });
  const [leaveAllow, setLeaveAllow] = useState(false);

  const closeModal = () => {
    setLeave({
      employee_id: leave.employee_id,
      start_date: null,
      end_date: null,
      leave_type: "",
      message: "",
      leave_reason: "",
      leave_days: "",
      leave_apply_period: "1",
      first_name: "",
      last_name: "",
    });
    setSelectedDate1(null);
    setSelectedDate2(null);
    setExtraLeaveError(false);
    setAppliedLeaveError(null);
    setIsModalOpen(false);
    setEditedID("");
    setUnpaidWarning(null);
    setHalfDay(false);
    setLeaveError({});
    setLeaveNotAllow(false)
  };

  const navigate = useNavigate();

  const employeeID = localStorage.getItem("employeeID");

  const empDetails = getEmployeeLocalDetails();

  const validationSchema = Yup.object({
    leave_type: createCustomSchema("dropdown", {
      message: "Select leave type",
    }),
    start_date: createCustomSchema("date", {
      message: "Enter start date",
    }),
    end_date: createCustomSchema("date", {
      message: "Enter end date",
    }),
    leave_reason: createCustomSchema("dropdown", {
      message: "Select leave reason",
    }),
  });

  useEffect(() => {
    const fetchReportingData = async () => {
      try {
        const response = await api.get(`reportees/${employeeID}`);
        const reportees = response.data.map((reportee, index) => ({
          value: reportee.employee_id,
          label:
            reportee.employee_first_name + " " + reportee.employee_last_name,
        }));
        setReportingData(reportees);
      } catch (error) {
        console.error("Error fetching reporting data:", error);
      }
    };

    fetchReportingData();
    checkCanTakeLeave();
  }, [employeeID]);

  console.log("leaveNotAllow", leaveNotAllow)

  useEffect(() => {
    setLeave({ ...leave, employee_id: employeeID });
  }, []);

  useEffect(() => {
    if (leave.end_date) {
      calculateDays();
      getLeaveDates(leave.start_date, leave.end_date);
    }
  }, [selectedDate1, selectedDate2]);

  const calculateDays = () => {
    const fromDate = leave.start_date;
    const toDate = leave.end_date;
    if (fromDate && toDate) {
      if (toDate < fromDate) {
        setDaysError("Start date cannot be earlier than end date.");
      } else {
        // const daysBetween =
        //   differenceInDays(new Date(toDate), new Date(fromDate)) + 1;
        setDaysError("");
        // setLeave({ ...leave, leave_days: daysBetween });
      }
    }
  };

  function getLeaveDates(startDateStr, endDateStr) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const leaveDates = [];
    const isStartWeekday = startDate.getDay() !== 6 && startDate.getDay() !== 0;
    const isEndWeekday = endDate.getDay() !== 6 && endDate.getDay() !== 0;
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      const dayOfWeek = currentDate.getDay();
      if (isStartWeekday && isEndWeekday) {
        leaveDates.push(new Date(currentDate));
      } else {
        if (dayOfWeek !== 6 && dayOfWeek !== 0) {
          leaveDates.push(new Date(currentDate));
        }
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    checkBalanceLeave(leaveDates.length);
    if (monthlyLeaveTaken?.length > 0) {
      if (monthlyLeaveTaken[0]?.remainingLeaves == true) {
        const selectedLeaveDayes = leave?.leave_apply_period != 1 ? 0.5 : leaveDates.length;
        if (selectedLeaveDayes > monthlyLeaveTaken[0]?.leave) {
          setLeaveError({ ...leaveError, end_date: `You are not Allowed to take more than ${monthlyLeaveTaken[0]?.leave}  leaves for selected month` })

        }
        else {
          setLeaveError({ ...leaveError, end_date: "" })
        }
      }
    }
    setLeave({
      ...leave,
      leave_days: leave?.leave_apply_period != 1 ? 0.5 : leaveDates.length,
    });
  }

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setLeave({ ...leave, [name]: value });
  };

  const isLeaveAppliedInAdvance = (startDate) => {
    const currentDate = new Date();

    const startDateMillis = startDate.getTime();
    const currentDateMillis = currentDate.getTime();
    const differenceMillis = Math.abs(currentDateMillis - startDateMillis);

    const differenceDays = Math.ceil(differenceMillis / (1000 * 60 * 60 * 24));
    if (!(differenceDays > 7)) {
      setLeaveAppliedInAdvanceError("Apply before 1 week");
    }
    return differenceDays > 7;
  };

  const fetchBalanceLeavesDays = async (id) => {
    if (!id) {
      return;
    }
    try {
      const employee_id = localStorage.getItem("employeeID");
      const company_id = companyID();
      const response = await api.get(
        `balance-leave/${leave.employee_id ?? employee_id}/${id}/${company_id}`
      );
      if (response?.data?.success === true) {
        response?.data?.result[0]?.total_days
          ? setBalanceDays(response?.data?.result[0]?.total_days)
          : response?.data?.result[0]?.remaining_days
            ? setBalanceDays(response?.data?.result[0]?.remaining_days)
            : setBalanceDays(0);
      }
    } catch (err) {
      console.error("Levae type Id response", err);
    }
  };

  useEffect(() => {
    if (leave?.leave_type) {
      fetchBalanceLeavesDays(leave?.leave_type);
    }
  }, [editedID, leave?.id, selectedDate2]);

  const [seletedLeaveType, setSelectedLeaveType] = useState({});
  const [monthlyLeaveTaken, setMonthlyLeaveTaken] = useState([]);
  const handleDropDownChange = async (key, selectedOption) => {
    const company_id = companyID();
    setLeave((prevState) => ({
      ...prevState,
      [key]: selectedOption.value,
    }));
    if ((key == "leave_type" || key == "employee_id") && selectedOption?.monthly_allow_leaves != 0) {
      const response = await api.get(`employee_leave_availibility?employee_id=${leave?.employee_id}&leave_type=${key == "leave_type" ? selectedOption?.value : leave?.leave_type}&company_id=${company_id}`)

      if (response?.data?.result?.length > 0) {

        if (response?.data?.result[0]?.remainingLeaves == false) {

          setAppliedLeaveError(
            response?.data?.message
          );
          setUnpaidWarning(null);

          return;
        }
        else {
          setMonthlyLeaveTaken(response?.data?.result);
          setLeaveError({ ...leaveError, [key]: "", notAllow: "" });
        }

      }
      else {
        setMonthlyLeaveTaken([]);
        setUnpaidWarning(null);
      }
    }


    setLeaveError({ ...leaveError, [key]: "", notAllow: "" });
    setLeaveAppliedInAdvanceError("");

    if (selectedOption?.value == 4) {
      setUnpaidWarning(selectedOption?.message);
    } else {
      setUnpaidWarning(null);
    }

    if (key !== "leave_reason") {
      setAppliedLeaveError(null);
      setSelectedDate1(null);
      setSelectedDate2(null);
      setExtraLeaveError(false);
      setLeave({
        ...leave,
        start_date: null,
        end_date: null,
        leave_days: 0,
        [key]: selectedOption.value,
      });
      setSelectedLeaveType(selectedOption);
      fetchBalanceLeavesDays(selectedOption.value);
    }
  };

  const [balanceLeave, setBalanceLeave] = useState(0);

  const checkBalanceLeave = (leave_days) => {
    console.log("balanceDays", balanceDays);
    if (leave?.leave_apply_period != 1) {
      leave_days = 0.5;
    }
    if (
      leave_days != null &&
      balanceDays != null &&
      !editedID &&
      seletedLeaveType?.check_leave_balance == 1
    ) {
      if (balanceDays < leave_days) {
        setAppliedLeaveError(
          `You have Only ${formatDecimal(balanceDays)} leaves are remaining ! `
        );
        setBalanceLeave(balanceDays);
        setExtraLeaveError(true);
        return; // open modal for extra Leave taken;
      } else {
        setAppliedLeaveError(seletedLeaveType?.message);
        // setAppliedLeaveError(null);
        setExtraLeaveError(false);
      }
    } else if (leave_days != null && balanceDays != null && editedID) {
      if (balanceDays + previousLeaveDays < leave_days) {
        setAppliedLeaveError(
          `You have Only ${formatDecimal(
            balanceDays + previousLeaveDays
          )} leaves are remaining ! `
        );
        // setAppliedLeaveError(seletedLeaveType?.message)
        setBalanceLeave(balanceDays + previousLeaveDays);
        setExtraLeaveError(true);
        return;
      } else {
        setAppliedLeaveError(seletedLeaveType?.message);
        setExtraLeaveError(false);
      }
    }
  };

  const formatDateForSQL = (date) => {
    return format(date, "yyyy-MM-dd");
  };

  const handleDateChange1 = (date) => {
    setSelectedDate1(date);
    setLeaveAppliedInAdvanceError("");
    const start_date = formatDateForSQL(date);
    if (leave?.leave_apply_period != 1) {
      fetchBalanceLeavesDays(editedID);
      setLeave({ ...leave, start_date: start_date, end_date: start_date });
      setLeaveError({ ...leaveError, end_date: null, start_date: null });
    } else {
      setLeave({ ...leave, start_date: start_date });
      setLeaveError({ ...leaveError, start_date: null });
    }
  };

  const handleDateChange2 = (date) => {
    setLeaveAppliedInAdvanceError("");
    setSelectedDate2(date);
    const end_date = formatDateForSQL(date);
    setLeave({ ...leave, end_date: end_date });
    setLeaveError({ ...leaveError, end_date: null });
    fetchBalanceLeavesDays(editedID);
  };

  const leaveReason = [
    { value: 1, label: "Illness" },
    { value: 2, label: "Family Emergency" },
    { value: 3, label: "Childcare" },
    { value: 4, label: "Vacation Travel" },
    { value: 5, label: "Personal Reasons" },
    { value: 6, label: "Medical Appointment" },
  ];

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };

  const handleHalfDaySwitch = (e) => {
    setHalfDay(e.target.checked);
    if (e.target.checked !== true) {
      setLeave({ ...leave, leave_apply_period: "1" });
    }
  };

  const handlePeriodChange = (e) => {
    setSelectedDate1(null);
    setSelectedDate2(null);
    setLeave({
      ...leave,
      start_date: null,
      end_date: null,
      leave_days: 0,
      leave_apply_period: e.target.value,
    });
  };

  const hideAcknowledgmentPopup = () => {
    const resetAcknowledgmentPopupData = () => {
      setAcknowledgmentPopup({
        show: false,
        status: null,
        message: null,
        icon: null,
      });
      closeModal();
    };
    setTimeout(() => resetAcknowledgmentPopupData(), 2000);
  };

  const applyLeave = (e) => {
    e.preventDefault();
    if (extraLeaveError == true) {
      setAppliedLeaveError(
        `You have only ${formatDecimal(balanceLeave)} leaves remaining!`
      );
      return;
    }

    let eligibleForCasualAndVacationLeave = true;
    const start_date = new Date(leave.start_date);
    // Restrict unpaid leave for interns
    if (empDetails.employment_status === "intern" && leave.leave_type === 4) {
      setAppliedLeaveError(
        "Interns are not eligible for unpaid leave application."
      );
      return;
    }

    // For interns, allow only casual leave (type 2) without advance check
    if (empDetails.employment_status === "intern" && leave.leave_type === 2) {
      eligibleForCasualAndVacationLeave = true;
    }

    // For non-interns, require advance application for casual (2) or vacation (3) leave
    if (
      empDetails.employment_status !== "intern" &&
      (leave.leave_type === 2 || leave.leave_type === 3)
    ) {
      eligibleForCasualAndVacationLeave = isLeaveAppliedInAdvance(start_date);
    }

    if (!daysError && eligibleForCasualAndVacationLeave) {
      setLeaveAppliedInAdvanceError("");
      if (editedID) {
        const leave_data = {
          ...leave,
          company_id: companyID(),
          previousLeaveDays: previousLeaveDays,
        };
        setLoading({ show: true, message: "Updating Leave..." });
        api
          .put(`applyLeave/${editedID}`, leave_data)
          .then((response) => {
            setAcknowledgmentPopup({
              show: true,
              status: "success",
              message: "Leave updated successfully !",
              icon: "fa-regular fa-circle-check",
            });
          })
          .catch((error) => {
            setAcknowledgmentPopup({
              show: true,
              status: "warning",
              message: "Something went wrong!",
              icon: "fa-regular fa-circle-xmark",
            });
          })
          .finally(() => {
            setLoading({ show: false, message: "" });
            hideAcknowledgmentPopup();
          });
      } else {
        const leave_data = { ...leave, company_id: companyID() };
        setLoading({ show: true, message: "Applying leave ..." });
        api
          .post(`applyLeave`, leave_data)
          .then((response) => {
            setAcknowledgmentPopup({
              show: true,
              status: "success",
              message: "Leave applied successfully !",
              icon: "fa-regular fa-circle-check",
            });
          })
          .catch((error) => {
            setAcknowledgmentPopup({
              show: true,
              status: "danger",
              message: "Something went wrong",
              icon: "fa-regular fa-circle-xmark",
            });
          })
          .finally(() => {
            hideAcknowledgmentPopup();
            setLoading({ show: false, message: "" });
          });
      }
    } else {
      console.error("submit fail");
    }
  };

  const getSelectedOption = (options, value) => {
    return options.find((option) => option.value === value);
  };

  const fetchAllowedLeaves = async (employeeId) => {
    if (!employeeId) {
      return [];
    }
    try {
      const response = await getAllowedLeaves(employeeId);
      return response.allowedLeaves ?? [];
    } catch (error) {
      console.error("Error fetching allowed leaves:", error);
      return [];
    }
  };

  function leavePermission(start_date, end_date, allowedLeaves) {
    const start = new Date(start_date);
    const end = new Date(end_date);

    if (isNaN(start) || isNaN(end) || start > end) {
      return false;
    }

    const allowedSet = new Set(allowedLeaves);

    for (
      let date = new Date(start);
      date <= end;
      date.setDate(date.getDate() + 1)
    ) {
      const dateString = date.toISOString().split("T")[0];
      if (!allowedSet.has(dateString)) {
        return false;
      }
    }

    return true;
  }

  const onSubmitLeave = async (e) => {
    e.preventDefault();
    try {
      await validationSchema.validate(leave, { abortEarly: false });
      setLeaveError({});
      applyLeave(e);
    } catch (error) {
      const newError = {};

      error.inner.forEach((err) => {
        newError[err.path] = err.message;
      });
      setLeaveError(newError);
    }
  };

  const checkLeaveAllowance = async () => {
    try {
      const result = await checkAllowanceForAbsent(
        leave.employee_id,
        leave.start_date,
        leave.end_date
      );

      if (!result.success) return;

      const leaveDates = result.allowances.leave;

      if (!leaveDates || leaveDates.length === 0) {
        setLeaveAllow(false);
        setLeaveError((prev) => ({
          ...prev,
          notAllow: `You are not allowed to take leave from ${leave.start_date} to ${leave.end_date}.`,
        }));
        return;
      }

      const allowedDatesSet = new Set(
        leaveDates.map((d) => new Date(d).toDateString())
      );

      const startDate = new Date(leave.start_date);
      const endDate = new Date(leave.end_date);
      let isLeaveAllowed = true;

      for (
        let d = new Date(startDate);
        d <= endDate;
        d.setDate(d.getDate() + 1)
      ) {
        if (!allowedDatesSet.has(d.toDateString())) {
          isLeaveAllowed = false;
          break;
        }
      }

      setLeaveAllow(isLeaveAllowed);

      if (!isLeaveAllowed) {
        setLeaveError((prev) => ({
          ...prev,
          notAllow: `You are not allowed to take leave from ${leave.start_date} to ${leave.end_date}.`,
        }));
      }
    } catch (error) {
      const { response } = error;
      if (response?.data?.notAllow && response?.data?.date) {
        setLeaveAllow(false);
        setLeaveError({
          notAllow: `You are not allowed to take leave from ${leave.start_date} to ${leave.end_date}.`,
        });
      }
    }
  };

  useEffect(() => {
    if (leave.start_date && leave.end_date) {
      checkLeaveAllowance();
    }
  }, [leave.start_date, leave.end_date]);

  return (
    <div
      id="add_leave"
      className={`modal custom-modal fade ${isModalOpen ? "show d-block" : ""}`}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {editedID ? "Edit Leave " : "Add Leave"}
            </h5>
            <button type="button" className="btn-close" onClick={closeModal}>
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            {leaveNotAllow && <div className="text-danger">* You are not allow to take leave.</div>}
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="input-block mb-3">
                <Form.Check
                  inline
                  label="For myself"
                  name="group1"
                  type="radio"
                  id="radio1"
                  checked={!showReportees}
                  onChange={() => {
                    setShowReportees(false);
                    setLeave({ ...leave, employee_id: employeeID });
                  }}
                />
                {reportingData.length > 0 && (
                  <Form.Check
                    inline
                    label="For other"
                    name="group1"
                    type="radio"
                    id="radio2"
                    checked={showReportees}
                    onChange={() => setShowReportees(true)}
                  />
                )}
              </div>
              {showReportees && (
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Select Employee <span className="text-danger">*</span>
                  </label>
                  <Select
                    disabled={leaveNotAllow ? true : false}
                    options={reportingData}
                    placeholder="Select"
                    styles={customStyles}
                    onChange={(selectedOption) =>
                      handleDropDownChange("employee_id", selectedOption)
                    }
                  />
                </div>
              )}
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Leave Type <span className="text-danger">*</span>
                </label>
                <Select
                  options={leaveTypeData}
                  placeholder="Select"
                  styles={customStyles}
                  value={
                    leave.leave_type
                      ? getSelectedOption(leaveTypeData, leave.leave_type)
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleDropDownChange("leave_type", selectedOption)
                  }
                  isDisabled={editedID || leaveNotAllow ? true : false}
                />
                {unpaidWarning && (
                  <span className="text-warning">
                    <i class="fa-solid fa-triangle-exclamation"></i>{" "}
                    {unpaidWarning}
                  </span>
                )}
                {appliedLeaveError && (
                  <span className="text-danger">*{appliedLeaveError}</span>
                )}
                {leaveError.leave_type && (
                  <span className="text-danger">*{leaveError.leave_type}</span>
                )}
              </div>
              {[1, 2, 4].includes(leave.leave_type) && (
                <div className="input-block mb-3 d-flex gap-2">
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label="Half day"
                    onChange={handleHalfDaySwitch}
                  />

                  {halfDay && (
                    <>
                      <Form.Check
                        inline
                        label="First half"
                        name="group2"
                        type="radio"
                        id="radio3"
                        value={2}
                        checked={leave.leave_apply_period === "2"}
                        onChange={handlePeriodChange}
                      />
                      <Form.Check
                        inline
                        label="Second half"
                        name="group2"
                        type="radio"
                        id="radio4"
                        value={3}
                        checked={leave.leave_apply_period === "3"}
                        onChange={handlePeriodChange}
                      />
                    </>
                  )}
                </div>
              )}
              <div className="input-block mb-3">
                <label className="col-form-label">
                  From <span className="text-danger">*</span>
                </label>
                <div className="cal-icon">
                  <DatePicker
                    selected={
                      selectedDate1 ||
                      (leave.start_date ? new Date(leave.start_date) : null)
                    }
                    onChange={handleDateChange1}
                    className="form-control datetimepicker"
                    type="date"
                    dateFormat="dd-MM-yyyy"
                    disabled={leave.leave_type || !leaveNotAllow ? false : true}
                  />
                  {leaveError.start_date && (
                    <span className="text-danger">
                      *{leaveError.start_date}
                    </span>
                  )}
                  {leaveAppliedInAdvanceError && (
                    <span className="text-danger">
                      *{leaveAppliedInAdvanceError}
                    </span>
                  )}
                </div>
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  To <span className="text-danger">*</span>
                </label>
                <div className="cal-icon">
                  <DatePicker
                    selected={
                      selectedDate2 ||
                      (leave.end_date ? new Date(leave.end_date) : null)
                    }
                    onChange={handleDateChange2}
                    className="form-control datetimepicker"
                    type="date"
                    dateFormat="dd-MM-yyyy"
                    disabled={
                      leave?.leave_apply_period != 1 || !leave.leave_type || leaveNotAllow
                        ? true
                        : false
                    }
                  />
                  {leaveError.end_date && (
                    <span className="text-danger">*{leaveError.end_date}</span>
                  )}
                </div>
                {daysError && (
                  <>
                    <span className="text-danger">* {daysError}</span>
                    <br />
                  </>
                )}

                {leaveAllow === false && leaveError.notAllow && (
                  <span className="text-danger">*{leaveError.notAllow}</span>
                )}
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Number of days <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  readOnly
                  type="text"
                  value={formatDecimal(leave.leave_days)}
                />
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Leave reason <span className="text-danger">*</span>
                </label>
                <Select
                  options={leaveReason}
                  placeholder="Select"
                  styles={customStyles}
                  value={
                    leave.leave_reason
                      ? getSelectedOption(leaveReason, leave.leave_reason)
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleDropDownChange("leave_reason", selectedOption)
                  }
                  isDisabled={leaveNotAllow ? true : false}
                />
                {leaveError.leave_reason && (
                  <span className="text-danger">
                    *{leaveError.leave_reason}
                  </span>
                )}
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">Message</label>
                <textarea
                  name="message"
                  rows={4}
                  className="form-control"
                  value={leave.message}
                  onChange={handleOnChange}
                  disabled={leaveNotAllow ? true : false}
                />
              </div>
              <div className="submit-section">
                <button
                  className="btn btn-primary submit-btn"
                  type="submit"
                  style={{
                    cursor: appliedLeaveError ? "not-allowed" : "pointer",
                  }}
                  disabled={
                    appliedLeaveError || loading.show || !leaveAllow
                      ? true
                      : false
                  }
                  onClick={onSubmitLeave}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {acknowledgmentPopup.show ? (
        <AcknowledgmentPopup
          popupVariant={acknowledgmentPopup.status}
          popupMessage={acknowledgmentPopup.message}
          popupIcon={acknowledgmentPopup.icon}
        />
      ) : (
        <></>
      )}
      {acknowledgmentPopup.show && (
        <div className="modal-backdrop fade show"></div>
      )}
      <Loader show={loading.show} loadingMessage={loading.message} />
    </div>
  );
};

export default EmployeeLeaveModelPopup;
